import sriWelcomeEn from "../../assets/hospital/video/sri/sri_welcome_en.mp4";
import sriWelcomeId from "../../assets/hospital/video/sri/sri_welcome_id.mp4";
import sriHowEn from "../../assets/hospital/video/sri/sri_how_en.mp4";
import sriHowId from "../../assets/hospital/video/sri/sri_how_id.mp4";
import sriLmkEn from "../../assets/hospital/video/sri/sri_lmk_en.mp4";
import sriLmkId from "../../assets/hospital/video/sri/sri_lmk_id.mp4";
import sriHiEn from "../../assets/hospital/video/sri/sri_hi_en.mp4";
import sriHiId from "../../assets/hospital/video/sri/sri_hi_id.mp4";

import jonathanWelcomeEn from "../../assets/hospital/video/jonathan/jonathan_welcome_en.mp4";
import jonathanWelcomeId from "../../assets/hospital/video/jonathan/jonathan_welcome_id.mp4";
import jonathanHowEn from "../../assets/hospital/video/jonathan/jonathan_how_en.mp4";
import jonathanHowId from "../../assets/hospital/video/jonathan/jonathan_how_id.mp4";
import jonathanLmkEn from "../../assets/hospital/video/jonathan/jonathan_lmk_en.mp4";
import jonathanLmkId from "../../assets/hospital/video/jonathan/jonathan_lmk_id.mp4";
import jonathanHiEn from "../../assets/hospital/video/jonathan/jonathan_hi_en.mp4";
import jonathanHiId from "../../assets/hospital/video/jonathan/jonathan_hi_id.mp4";

const hospitalVideoConfig = {
  Sri: {
    EN: [
      {
        video: sriWelcomeEn,
        introMessage:
          "HI, welcome to our hospital’s virtual assistant service. I’m Nurse Sri.",
      },
      { video: sriHowEn, introMessage: "How are you feeling today?" },
      {
        video: sriLmkEn,
        introMessage:
          "Let me know if you need information about your medications or tips!",
      },
      {
        video: sriHiEn,
        introMessage: "Hi, how can i address you?",
      },
    ],
    ID: [
      {
        video: sriWelcomeId,
        introMessage:
          "HI, selamat datang di layanan asisten virtual rumah sakit kami. Saya Perawat Sri.",
      },
      { video: sriHowId, introMessage: "Bagaimana perasaanmu hari ini?" },
      {
        video: sriLmkId,
        introMessage:
          "Beritahu saya jika Anda membutuhkan informasi tentang obat-obatan atau tips!",
      },
      {
        video: sriHiId,
        introMessage: "Halo, bagaimana saya bisa memanggil Anda?",
      },
    ],
  },
  Jonathan: {
    EN: [
      {
        video: jonathanWelcomeEn,
        introMessage:
          "HI, welcome to our hospital’s virtual assistant service. I’m Nurse Jonathan.",
      },
      { video: jonathanHowEn, introMessage: "How are you feeling today?" },
      {
        video: jonathanLmkEn,
        introMessage:
          "Let me know if you need information about your medications or tips!",
      },
      {
        video: jonathanHiEn,
        introMessage: "Hi, how can i address you?",
      },
    ],
    ID: [
      {
        video: jonathanWelcomeId,
        introMessage:
          "HI, selamat datang di layanan asisten virtual rumah sakit kami. Saya Perawat Jonathan.",
      },
      { video: jonathanHowId, introMessage: "Bagaimana perasaanmu hari ini?" },
      {
        video: jonathanLmkId,
        introMessage:
          "Beritahu saya jika Anda membutuhkan informasi tentang obat-obatan atau tips!",
      },
      {
        video: jonathanHiId,
        introMessage: "Halo, bagaimana saya bisa memanggil Anda?",
      },
    ],
  },
};

const language = sessionStorage.getItem("language") || "EN";

export const getNextStep = (currentStep, avatar) => {
  const videoList = hospitalVideoConfig[avatar]?.[language] || [];
  return Math.min(currentStep + 1, videoList.length - 1);
};

export const getVideoConfig = (avatar, step) => {
  return hospitalVideoConfig[avatar]?.[language]?.[step] || null;
};

export default hospitalVideoConfig;
